<template>
  <div class="d-flex flex-row">
    <v-combobox
      width="200"
      height="40px"
      class="search-keyword"
      v-model="keyword"
      multiple
      outlined
      hide-details
      chips
      label="Enter the keyword"
      style="max-height: 40px;margin-top: 12px;"
    >
      <template v-slot:selection="data">
        <v-chip
          :key="JSON.stringify(data.item)"
          :input-value="data.selected"
          :disabled="data.disabled"
          close
          @click:close="removeKeyword(data.item)"
          class="v-chip--select-multi"
        >{{ data.item }}</v-chip>
      </template>
    </v-combobox>
    <v-btn icon @click="dialog=true" class="setting-btn">
      <v-icon color="red lighten-2" dark>settings</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Settings</v-card-title>
        <v-card-text class="pt-2">
          <v-divider></v-divider>
          <p>Location</p>
          <v-combobox v-model="location" :items="locations" label="Select influencer location"></v-combobox>
          <v-divider></v-divider>
          <v-text-field
            outlined
            v-model="negativeKeyword"
            type="text"
            clearable
            label="Negative Keyword"
          ></v-text-field>
          <v-divider></v-divider>
          <p class="body-2 font-weight-bold mt-3 pb-3">Duration in Year</p>
          <v-slider
            v-model="pastYear"
            ticks="always"
            min="1"
            max="10"
            step="1"
            :thumb-size="24"
            thumb-label="always"
          ></v-slider>
          <p class="caption">It will search posts from ({{pastDate}}) </p>
          <!-- <v-divider></v-divider>
          <p>Negative keyword scope</p>
          <v-radio-group v-model="negativePeriod">
            <v-radio :label="'Search period'" :value="'search_period'"></v-radio>
            <v-radio :label="'Entire Account'" :value="'entire_account'"></v-radio>
          </v-radio-group>
          <v-text-field
            outlined
            v-model="searchDuration"
            type="number"
            label="Search Period(months)"
            v-if="negativePeriod === 'search_period'"
          ></v-text-field>
          <v-divider></v-divider> -->
          <!-- <p>Enable</p>
          <v-checkbox v-model="computerVison" hide-details :label="`Computer Vision`"></v-checkbox>
          <v-checkbox v-model="searchNlu" hide-details :label="`NLU`"></v-checkbox>
          <v-divider></v-divider>
          <p>Opt-in Only</p>
          <v-radio-group v-model="optInOnly">
            <v-radio :label="'Yes'" :value="true"></v-radio>
            <v-radio :label="'No'" :value="false"></v-radio>
          </v-radio-group> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialog = false">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import influencerAPIs from '../../views/Influencer/influencerAPIs';
import moment from 'moment';
export default {
  name: 'KInfluencerSearchBox',
  props: {
    search: String,
    page: Number,
    limit: Number,
    sortBy: String,
    descending: Number
  }, // K === Kobe,
  data() {
    return {
      dialog: false,
      // Setting search influencer by keyword
      keyword: [],
      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      location: null,
      locations: ['Singapore', 'Thailand', 'Philippin', 'Malaysia', 'Indonesia'],
      pastYear: 3
    };
  },
  computed: {
    searchKeywordPayload() {
      return {
        keyword: this.keyword,
        negative_keyword: this.negativeKeyword,
        negative_period: this.negativePeriod,
        opt_in_only: this.optInOnly,
        search_duration: this.searchDuration,
        search_image: false,
        search_nlu: this.searchNlu,
        location: this.location,
        pastYear: this.pastYear
      }
    },
    pastDate() {
      return moment().subtract(this.pastYear, 'years').format('DD-MM-YYYY')
    }
  },
  watch: {
    search(value) {
      this.searchByKeywords();
    }
  },
  methods: {
    searchByKeywords() {
      if (this.keyword.length === 0) {
        this.$swal({
          title: 'Warning',
          text: 'Please enter the keyword',
          type: 'info'
        });
        this.$emit('result', { success: false, nokeyword: true });
      } else {
        influencerAPIs
          .searchKeyword(this.searchKeywordPayload, this.sortBy, this.descending, this.limit, this.page)
          .then(response => {
            let originalItems = response.influencers;
            let totalItems = response.totalInfluencers;
            let summary = response.summary;
            this.$emit('result', { success: true, originalItems, totalItems, summary, keyword: this.keyword });
          })
          .catch(error => {
            console.log(error);
            this.$emit('result', { success: false });
          });
      }
    },
    removeKeyword(item) {
      let index = this.keyword.indexOf(item);
      if (index !== -1) {
        this.keyword.splice(index, 1);
      }
    }
  }
};
</script>
<style>
.setting-btn {
  margin-top: 22px;
}
</style>



// WEBPACK FOOTER //
// InfluencerSearchBox.vue?941733b2